import { useRouter } from "next/router";

const ConstituencyLinks = ({
  constituencyListData = [],
  customTitle = "",
  electionPassedCategory = "",
  autoLiveBlogRedirect = false,
}) => {
  const router = useRouter();
  const currentPath = router?.asPath;
  const constituencyId =
    currentPath?.split("-")[currentPath?.split("-").length - 1];
// console.log('constituencyListData11', constituencyListData);
const isFiveStates = ["west-bengal", "assam", "tamil-nadu", "puducherry", "kerala"].some((state) =>  router?.asPath?.includes(state));

  return (
    constituencyListData &&
    constituencyListData?.length > 0 && (
      <div className="my-1 mx-2 bg-[#FFF] dark:bg-[#000] rounded-[10px]">
        {customTitle != "" && (
          <div className="text-dark-bg font-bold text-lg sm:text-xl xs:text-xl min-w-[28%] flex items-center mb-[4px]">
            {/* <RiLinksFill className="font-800 mr-[4px] dark:text-dark-text" /> */}
            <h2 className="dark:text-dark-text">{customTitle}</h2>
          </div>
        )}
        <div
          className={`flex flex-wrap gap-x-2 p-2 border-2 border-[#E6E7E9]-500 rounded-[20px]`}
        >
          {constituencyListData?.map((item, index) => {
            return (
              <a
                key={index}
                title={item?.cons_name}
                href={
                  autoLiveBlogRedirect
                    ? `${
                        process?.env?.NEXT_PUBLIC_WEBSITE_URL
                      }/elections/${electionPassedCategory}/${item?.cons_name
                        .toLowerCase()
                        .replace(/[^a-zA-Z ]/g, "")
                        .split(" ")
                        .join("-")}-assembly-constituency-result-${item?.cons_id}`
                    : (item.blogUrl ||
                      `${
                        process?.env?.NEXT_PUBLIC_WEBSITE_URL
                      }/elections/${electionPassedCategory}/${item?.cons_name
                        .toLowerCase()
                        .replace(/[^a-zA-Z ]/g, "")
                        .split(" ")
                        .join("-")}-assembly-constituency-result-${item?.cons_id}`)
                }
                target={"_self"}
              >
                <div
                  key={index}
                  className={` dark:bg-[#1F1F1F] dark:border-[#1F1F1F] my-1 border-2 border-[#D2D1D1]-500 rounded-[20px] px-4 py-2 ${
                    item?.cons_id == constituencyId
                      ? isFiveStates ? "bg-primary text-[#FFF]" : "bg-[#CF4C9B] text-[#FFF]"
                      :  "bg-[#EEF3F7] hover:bg-[#F5B301]"
                  } `}
                >
                  <p
                    className={` whitespace-nowrap`}
                    style={{ textWrap: "nowrap" }}
                  >
                    {item?.cons_name_en || item?.cons_name_hi}
                  </p>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    )
  );
};

export default ConstituencyLinks;
